import { NgModule } from '@angular/core';
import { CommonModule, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { AssignTableComponent } from './components/table/assign-table.component';
import { AssignComponent } from './assign.component';
import { AssignRoutingModule } from './assign-routing.module';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { SaveasbatchComponent } from './components/saveasbatch/saveasbatch.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { HolddialogComponent } from './dialogs/holddialog/holddialog.component';
import { ScheduledialogComponent } from './dialogs/scheduledialog/scheduledialog.component';
import { DownloadorderdialogComponent } from './dialogs/downloadorderdialog/downloadorderdialog.component';
import { MatRadioModule } from '@angular/material/radio';
import { SharedModule } from 'src/app/sharedModule/shared.module';
import { MatChipsModule } from '@angular/material/chips';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { AdvancedFiltersComponent } from './components/advanced-filters/advanced-filters.component';
import { AdvancedFilterDeleteDialogComponent } from './components/advanced-filter-delete-dialog/advanced-filter-delete-dialog.component';
import { ActionContainer } from './components/action-container/action-container.component';
import { CdkTableModule } from '@angular/cdk/table';
import * as fromAssign from './store/reducers';
import { AdvancedFiltersEffects } from './store/effects';
import { MatDividerModule } from '@angular/material/divider';
import { AdvancedFiltersManageSide } from './components/advanced-filters-manage-side/advanced-filters-manage-side';
import { SaveAsBatchNewComponent } from './components/save-as-batch-new/save-as-batch-new.component';
import { SaveAsBatchTableComponent } from './components/save-as-batch-table/save-as-batch-table.component';
import { StorybookModule } from '@storybook/storybook.module';
import { AssignGroupByComponent } from './components/assign-group-by/assign-group-by.component';
import { SnoozeComponent } from './dialogs/snooze/snooze.component';
import { AssignToCarrier } from '@pages/workspace/assign/components/assign-to-carrier/assign-to-carrier';
import { AddToBatchesTableComponent } from './components/add-to-batches-table/add-to-batches-table.component';
import { MentionsFiltersComponent } from './components/assign-mentions-filter/assign-mentions-filter.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { CalculateGroupTableHeightPipe } from './pipes/assign-pipes';

const PIPES = [CalculateGroupTableHeightPipe];
@NgModule({
  declarations: [
    ActionContainer,
    AssignTableComponent,
    AssignComponent,
    SaveasbatchComponent,
    HolddialogComponent,
    ScheduledialogComponent,
    DownloadorderdialogComponent,
    AdvancedFiltersComponent,
    AdvancedFilterDeleteDialogComponent,
    AdvancedFiltersManageSide,
    SaveAsBatchNewComponent,
    SaveAsBatchTableComponent,
    AssignGroupByComponent,
    SnoozeComponent,
    AssignToCarrier,
    AddToBatchesTableComponent,
    MentionsFiltersComponent,
    ...PIPES,
  ],
  imports: [
    CommonModule,
    SharedModule,
    AssignRoutingModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatRadioModule,
    OverlayModule,
    MatIconModule,
    MatProgressSpinnerModule,
    StoreModule.forFeature(fromAssign.featureKey, fromAssign.reducers),
    EffectsModule.forFeature([AdvancedFiltersEffects]),
    MatDividerModule,
    CdkTableModule,
    StorybookModule,
  ],
  exports: [AssignTableComponent],
  providers: [Location, { provide: LocationStrategy, useClass: PathLocationStrategy }],
})
export class AssignModule {}
